import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql,useApolloClient } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from "primereact/inputtext";
import { Link, useNavigate } from "react-router-dom";
import { TabView, TabPanel } from 'primereact/tabview';
import { RadioButton } from "primereact/radiobutton";
import { Fieldset } from 'primereact/fieldset';
import { Divider } from 'primereact/divider';
import { Calendar } from 'primereact/calendar';
import { addLocale } from 'primereact/api';
import { PrimeReactProvider } from "primereact/api";
import { Dialog } from 'primereact/dialog';
import HtlAgnSeaReduction from "./HtlAgnSeaReduction";
import HtlAgnSeasonPriceEdit from "./HtlAgnSeasonPriceEdit";
import HtlAgnOffresEdit from "../../../hoteladm/hotel/offers/HtlAgnOffresEdit";
import HtlAgnOffresGrp from "../../../hoteladm/hotel/offers/HtlAgnOffres";






import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';

const GET_POST = gql`
  query MyQuery12(
    $firmMainCode: String
    $firmSubCode: String
    $contIdSeq : Int
 
   
    

  ) {
    tbl_cont_per_price(
      order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $firmMainCode }
        firm_sub_code: { _eq: $firmSubCode }
        cont_id: { _eq: $contIdSeq }
       
       
        
      }
    ) {
      firm_main_code
      firm_sub_code
      period
      cont_id
      r_type_code
      adult
      child
      per_price
      currency
    
    
    }
  }
`;




const HtlAgnSeasonPriceResult = () => {
    const { users } = useContext(UserContext);
    const { firmcode, subfirmcode, usertype, userLang } = users;
    const { id_seq } = useParams();
    const {varCode3, setVarCode3} = useContext(ThemeContext);
    const {varCode4, setVarCode4} = useContext(ThemeContext);
    const {varCode5, setVarCode5} = useContext(ThemeContext);
    const {varCode6, setVarCode6} = useContext(ThemeContext);
    const {varCode7, setVarCode7} = useContext(ThemeContext);
    const {varCode8, setVarCode8} = useContext(ThemeContext);
    const [someCondition, setSomeCondition] = useState(false);

    const {varCode, setVarCode} = useContext(ThemeContext);
    
    const {varCode9, setVarCode9} = useContext(ThemeContext);
    const {varCode10, setVarCode10} = useContext(ThemeContext);
    const {varCode11, setVarCode11} = useContext(ThemeContext);
    const {varCode12, setVarCode12} = useContext(ThemeContext);
    const {varCode14, setVarCode14} = useContext(ThemeContext);
   
    
    const firmMainCode = firmcode;
    const firmSubCode = subfirmcode;
    const intl = useIntl();
    const currentLocale = userLang || localStorage.getItem('lang') || 'en';
  
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(0);
    const [activeTabS, setActiveTabS] = useState(9);
  
    const handleTabChange = (index) => {
      setActiveTab(index);
    };
  
    const handleTabChangeS = (index) => {
      setActiveTabS(index);
    };
  
    const { loading, error, data, refetch } = useQuery(GET_POST, {
      variables: { firmSubCode, firmMainCode, contIdSeq: varCode4 },
    });



   
   
 
  
  
    const firmData = data && data.tbl_cont_per_price ? data.tbl_cont_per_price : [];

    const [contIdSeq, setContIdSeq] = useState(firmData ? firmData.cont_id :"");
   


  const cont_detail_tab = messages[currentLocale].cont_detail_tab;

  const [tableData, setTableData] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);



    useEffect(() => {
        if (firmData) {  
               

          setContIdSeq(varCode4);
      
          refetch();  
          
    
        }
      }, [firmData]);


   
 


      useEffect(() => {
        // varCode4 değiştiğinde yapılacak işlemler
        setContIdSeq(varCode4);
        setVarCode4(varCode4);
        setSomeCondition(true);
        console.log("var:", varCode4)
        
        // refetch fonksiyonunu çağırma koşullarına bağlı olarak
        if (someCondition) {
          refetch();
         
        }
      }, [varCode4, setContIdSeq, someCondition]);


 
      
     

          
  
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

   
  
    return (

        
        <>

 
<DataTable
value={firmData}
scrollable 
scrollHeight="250px" 
loading={loading}
stickyHeader
stickyTopAt=".layout-topbar"


>



<Column field="r_type_code"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Room"}</span>}
 style={{ textAlign: 'left', width: '9rem' }}
>
</Column>
<Column field="period"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Period"}</span>}
 style={{ textAlign: 'left', width: '7rem' }}
>
</Column>

<Column field="adult"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Aduld"}</span>}
 style={{ textAlign: 'left', width: '15rem' }}
>
</Column>

<Column field="child"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Child"}</span>}
 style={{ textAlign: 'left', width: '15rem' }}
>
</Column>
<Column field="per_price"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Price"}</span>}
 style={{ textAlign: 'left', width: '15rem' }}
>
</Column>
<Column field="currency"
 className="text-xs text-right" 
 header={<span className="font-bold text-gray-900">{"Currency"}</span>}
 style={{ textAlign: 'left', width: '15rem' }}
>
</Column>


<Column
header={<span className="font-bold text-sm text-gray-900">{"detail"}</span>}
body={(rowData) => (
  <button
    onClick={() => {               
  //    setVarCode8(rowData.id_seq);  
      setVarCode(rowData.r_prn_id_seq);     
    //  setVarCode10(rowData.id_seq);   
      
      setVarCode11(rowData.rules_sub_type); //EBO
      setVarCode8(rowData.id_seq);
      setVarCode9("COFF")
     
    
      
    }}
    className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
  >
    <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>
  </button>
)}
style={{ textAlign: 'center', width: '6rem' }}
></Column>

</DataTable>

          
        </>
      );
      
  };
  
  export default HtlAgnSeasonPriceResult;

 


      
  